import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardFooter, Col, Input, Label, Row } from 'reactstrap';
import OSelect from '../../../../Components/OElements/OSelect';
import PageComponents from './Graph/PageComponents';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getGraphList } from '../../../../slices/thunks';

const TitleGraphGraphPage = ({ elements, page, handleDynamicChange, validation, edit, date_ini, date_end }) => {

    const text = elements.length > 0 ? elements[0].text : '';
    const graph1 = elements.length > 0 ? elements[0].graph1 : '';
    const graph2 = elements.length > 0 ? elements[0].graph2 : '';

    const dispatch = useDispatch();

    const selectorReport = createSelector(
        state => state.Screen,
        report => ({
            data: report.graphList || []  // Asegura que data sea un array vacío si es null o undefined
        })
    );

    const { data } = useSelector(selectorReport);

    const [graphNoEdit, setGraphNoEdit] = useState(null);
    const [selectedGraph1, setSelectedGraph1] = useState(graph1);
    const [selectedGraph2, setSelectedGraph2] = useState(graph2);
    const [selectedGraphCode1, setSelectedGraphCode1] = useState(null);
    const [selectedGraphCode2, setSelectedGraphCode2] = useState(null);
    const [typesList, setTypesList] = useState([]);

    const handleGraphSelect1 = (optionSelected) => {
        if (optionSelected?._id !== selectedGraph1?._id) {
            setSelectedGraph1(optionSelected);
            setSelectedGraphCode1(optionSelected?.code);
            handleDynamicChange(0, 'graph1', optionSelected?._id);
        }
    };

    const handleGraphSelect2 = (optionSelected) => {
        if (optionSelected?._id !== selectedGraph2?._id) {
            setSelectedGraph2(optionSelected);
            setSelectedGraphCode2(optionSelected?.code);
            handleDynamicChange(0, 'graph2', optionSelected?._id);
        }
    };

    useEffect(() => {
        dispatch(getGraphList());
    }, [dispatch]);

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {  // Verifica que data sea un array y tenga elementos antes de mapear
            const list = data.map(type => ({
                value: type._id,
                label: type.name,
                item: type
            }));
            setTypesList(list);

            if (graph1) {
                const foundType = data.find(type => type._id === graph1);
                setGraphNoEdit(foundType);
            }

            if (graph2) {
                const foundType = data.find(type => type._id === graph2);
                setGraphNoEdit(foundType);
            }
        }
    }, [data, graph1, graph2]);

    const SelectedGraphComponent1 = edit
        ? PageComponents[selectedGraphCode1]
        : PageComponents[graphNoEdit1?.code];
    const SelectedGraphComponent2 = edit
        ? PageComponents[selectedGraphCode2]
        : PageComponents[graphNoEdit2?.code];

    return (
        <Card className='border card-border-primary'>
            <CardBody>
                {edit && typesList.length > 0 ? (
                    <Row>
                        <Col md={6}>
                            <OSelect
                                label="Gráfico - Columna 1"
                                id="graph1"
                                name="graph1"
                                value={graph1}
                                onSelect={handleGraphSelect1}
                                itemsSelect={typesList}
                                validation={validation}
                            />
                        </Col>
                        <Col md={6}>
                            <OSelect
                                label="Gráfico - Columna 2"
                                id="graph2"
                                name="graph2"
                                value={graph2}
                                onSelect={handleGraphSelect2}
                                itemsSelect={typesList}
                                validation={validation}
                            />
                        </Col>
                    </Row>
                ) : null}
                <Row>
                    <Col md={6}>
                        {SelectedGraphComponent1 && (
                            <div style={{ height: '300px' }}>
                                <React.Suspense fallback={<div>Cargando...</div>}>
                                    <SelectedGraphComponent1
                                        date_ini={date_ini}
                                        date_end={date_end}
                                    />
                                </React.Suspense>
                            </div>
                        )}
                    </Col>
                    <Col md={6}>
                        {SelectedGraphComponent2 && (
                            <div style={{ height: '300px' }}>
                                <React.Suspense fallback={<div>Cargando...</div>}>
                                    <SelectedGraphComponent2
                                        date_ini={date_ini}
                                        date_end={date_end}
                                    />
                                </React.Suspense>
                            </div>
                        )}
                    </Col>
                </Row>
            </CardBody>
            <CardFooter className="bg-primary text-white">
                <Row className="g-0">
                    <Col md={12} className='p-2'>
                        <Label for="text" className="form-label">
                            Texto
                        </Label>
                        <Input
                            name="text"
                            id="text"
                            className="form-control"
                            placeholder="Ingrese un texto"
                            type="textarea"
                            value={text}
                            rows={3}
                            onChange={(e) => handleDynamicChange(0, 'text', e.target.value, page)}
                        />
                    </Col>
                </Row>
            </CardFooter>
        </Card>
    );
};

export default TitleGraphGraphPage;
